<template>
  <div
    class="w-full h-full px-[30px] py-[14px] md:py-[20px] max-h-[1198px] xl:max-h-[681px] lg:max-h-[1210px] 4xl:max-h-[853px] 5xl:max-h-[956px] rounded-[8px] bg-white shadow-[0_4px_8px_0_rgba(215,227,235,0.25)] flex flex-col"
  >
    <!-- Header -->
    <div class="border-none text-center py-[14px]">
      <h5
        class="text-[#000] m-0 font-['Poppins',sans-serif] !text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] font-semibold leading-normal"
      >
        Event Log
      </h5>
    </div>

    <!-- Body -->
    <div class="flex-1 overflow-auto custom-scrollbar">
      <div class="flex flex-col">
        <div
          v-for="(val, i) in eventList"
          :key="i"
          class="w-full"
        >
          <!-- Date label -->
          <div
            class="flex items-center justify-start text-[#218863] font-['Poppins',sans-serif] text-[16px] 4xl:!text-[20px] 5xl:!text-[28px] font-semibold leading-[23px] mt-[22px] mb-[12px] 5xl:mb-[26px] w-full"
          >
            {{ formatDate(val.date) }}
            <span
              class="flex-auto ml-[3px] h-[1px] bg-gradient-to-r from-[#218863] to-[rgba(191,191,191,0)]"
            ></span>
          </div>

          <!-- Event logs -->
          <div
            v-for="(event, index) in val.items"
            :key="index"
            class="w-full"
          >
            <div
              class="text-[#ababab] font-['Poppins',sans-serif] text-[16px] 4xl:!text-[20px] 5xl:!text-[28px] font-normal leading-[23px] 4xl:!leading-[30px] 5xl:!leading-[36px] my-[11px] 5xl:my-[18px]"
            >
              <strong
                class="text-[#ababab] font-['Poppins',sans-serif] text-[16px] 4xl:!text-[20px] 5xl:!text-[28px] font-semibold leading-[23px]"
              >
                [{{ event.time }} |
                <span :style="event.methodColor">{{ event.methods }}</span>]
              </strong>
              {{ event.log }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: ["eventLogs"],
  data() {
    return {
    };
  },
  computed: {
    eventList() {
      const groupedLogs = this.eventLogs.reduce((acc, log) => {
        let dateGroup = acc.find((group) => group.date === log.date);
        if (!dateGroup) {
          dateGroup = {
            date: log.date,
            items: [],
          };
          acc.push(dateGroup);
        }

        dateGroup.items.push({
          time: log.time,
          log: log.log,
          methods: log.methods,
          methodColor:
            log.methods.toUpperCase() == "AUTO"
              ? "color: #2A5CAA"
              : "color: #218863;",
        });
        return acc;
      }, []);
      return groupedLogs;
    },
  },
  methods: {
    formatDate(date) {
      const today = moment(date).isSame(moment().format("YYYY-MM-DD"));
      if (today) {
        return "Today";
      }
      return moment(date).format("DD MMMM YYYY");
    },
  },
};
</script>
